import { render, staticRenderFns } from "./wisdom-info.vue?vue&type=template&id=0c9c918c&scoped=true&"
import script from "./wisdom-info.vue?vue&type=script&lang=js&"
export * from "./wisdom-info.vue?vue&type=script&lang=js&"
import style0 from "./wisdom-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./wisdom-info.vue?vue&type=style&index=1&id=0c9c918c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c918c",
  null
  
)

export default component.exports